"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var UserManagement = __importStar(require("../../../user"));
var authentication_1 = __importDefault(require("../../../interface/user-management/user/authentication"));
var permission_1 = __importDefault(require("../../../interface/user-management/user/permission"));
var data_1 = require("./data");
var tokens_1 = __importDefault(require("./tokens"));
var extra = function (instanceUuid, withBackend, urlPrefix) { return [
    {
        title: 'Status',
        Component: function (_uuid, data) { return (react_1["default"].createElement(UserManagement.Status, { user: data, pList: data_1.statusList, update: data_1.updateStatus(withBackend) })); }
    },
    {
        title: 'Authentication Methods',
        Component: function (uuid) { return (react_1["default"].createElement(UserManagement.Authentications, { dataInterface: new authentication_1["default"](String(uuid), withBackend), urlPrefix: urlPrefix + "/" + uuid + "/detail" })); }
    },
    {
        title: 'Access Control',
        tab: 'Access-Control',
        width: { xs: 12, sm: 12, md: 12, lg: 12 },
        Component: function (uuid) { return (react_1["default"].createElement(UserManagement.Permissions, { uuid: String(uuid), permissionInterface: new permission_1["default"]('superadmin', { uuid: instanceUuid }) })); }
    },
    {
        tab: 'Tokens',
        width: { xs: 12, sm: 12, md: 12, lg: 12 },
        Component: function (uuid) { return (react_1["default"].createElement(tokens_1["default"], { urlPrefix: urlPrefix, userUuid: String(uuid), withBackend: withBackend })); }
    }
]; };
exports["default"] = (function (_a) {
    var urlPrefix = _a.urlPrefix, uuid = _a.uuid, withBackend = _a.withBackend;
    var prefix = urlPrefix + "/" + uuid + "/Users";
    return (react_1["default"].createElement(UserManagement.Crud, { urlPrefix: prefix, dataInterface: data_1.dataInterface(uuid, withBackend), extra: extra(uuid, withBackend, prefix) }));
});
